import { render, staticRenderFns } from "./AgentNameCol.vue?vue&type=template&id=5fbebe54&"
import script from "./AgentNameCol.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AgentNameCol.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports